import type { LucideIcon } from 'lucide-react';
import {
  Brain,
  ClipboardList,
  Compass,
  FilePenLine,
  FileText,
  GraduationCap,
  LayoutGrid,
  ListChecks,
  Mail,
  Mic,
  Search,
  ShieldCheck,
  Target
} from 'lucide-react';
import React, { useState } from 'react';

const ROADMAP_ICON_BY_STEP_ID: Record<string, LucideIcon> = {
  'todo-list': ListChecks,
  'career-vision': Compass,
  brainstorming: Brain,
  resume: FileText,
  'target-schools': Target,
  'letters-of-recommendation': Mail,
  essays: FilePenLine,
  'interview-prep': Mic,
  'test-strategy': GraduationCap,
  'school-research': Search,
  'application-forms': ClipboardList,
  'final-review': ShieldCheck
};

const iconProps = {
  className: 'roadmap-module-icon-svg',
  size: 44,
  strokeWidth: 1.6,
  absoluteStrokeWidth: false,
  'aria-hidden': true as const
};

function RoadmapModuleIconSvg({ stepId }: { stepId: string }) {
  const Icon = ROADMAP_ICON_BY_STEP_ID[stepId] ?? LayoutGrid;
  return <Icon {...iconProps} />;
}

/** Optional Clearbit (or any) logo URL; falls back to Lucide on load error */
export function RoadmapModuleVisual({
  stepId,
  logoUrl
}: {
  stepId: string;
  logoUrl?: string;
}) {
  const [logoFailed, setLogoFailed] = useState(false);

  if (logoUrl && !logoFailed) {
    return (
      <img
        src={logoUrl}
        alt=""
        className="roadmap-module-logo-img"
        loading="lazy"
        decoding="async"
        onError={() => setLogoFailed(true)}
      />
    );
  }

  return <RoadmapModuleIconSvg stepId={stepId} />;
}
